import React from "react";
import { useTranslation } from "react-i18next";

interface HeaderTypes {
  className?: string;
}

export default function PublicHeader(props: HeaderTypes) {
  const { className } = props;
  const { t } = useTranslation();

  return (
    <header className="w-full h-16 text-gray-white bg-primary-80 flex items-center px-4">
      <img width={60} src={"/sama-white.png"} />
    </header>
  );
}
